<style scoped>
td.comment {
  padding: 7px 0px;
  /* background: #f5f5f5; */
  /* border: 1px solid #CCCCCC; */
  /* margin-left: 45px; */
  border-radius: 15px;
  /* box-shadow: 0px 0px 3px #bbb; */
}
.comment .form-control {
  height: 35px;
}
td.tdimage {
  width: 55px;
  text-align: center;
}
td.padding10 {
  padding: 0 10px;
}
td.buttons {
  font-size: 18px;
  width: 65px;
  text-align: center;
}
.comment textarea {
  border-radius: 15px;
  width: 100%;
  /* padding: 6px 12px; */
  border-color: #e8e7e8;
}
</style>
<template>
  <table style="width: 100%; background: #dcf1ff" @click.stop>
    <tbody>
      <tr class="singleComment">
        <td class="padding10 tdimage">
          <img class="img-circle profilePic" :src="currentImage" />
        </td>
        <td class="comment">
          <textarea-autosize
            class="form-control"
            placeholder="Enter new comment"
            :minHeight="25"
            style="padding: 5px;padding-left: 5px"
            v-model="comment"
          ></textarea-autosize>
        </td>
        <td class="buttons" style="width: 100px">
          <el-button
            type="primary"
            round
            @click="postNewComment"
            class="round25"
            size="small"
            :disabled="fieldsAreFilled()"
            >Post</el-button
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style scoped></style>
<script>
import ApiService from "@/services/ApiService";
export default {
  name: "newComment",
  props: {
    id: Number,
    noticeUserId: Number,
  },
  data() {
    return {
      expanded: false,
      comment: "",
    };
  },
  methods: {
    likeComment() {
      alert("Like comment");
    },
    removeMyComment() {
      alert("testas");
    },
    fieldsAreFilled() {
      return this.comment == "";
    },
    postNewComment() {
      if (this.comment === "") {
        // toastr.info("Comment is required to proceed");
        return;
      }
      const _payload = {
        comment: this.comment,
        notice_id: this.id,
      };
      if (this.id) {
        _payload.notice_id = this.id;
      }

      if (this.noticeUserId) {
        _payload.noticeUserId = this.noticeUserId;
      }

      this.$store.dispatch("loading", true);

      ApiService.generalApi
        .saveComment(_payload)
        .then((data) => {
          this.$store.dispatch("loading", false);
          this.comment = "";
          this.$emit("newCommentAdded", data.data);
        })
        .catch(() => {
          this.$store.dispatch("loading", false);
        });
    },
  },
  computed: {
    currentImage: function () {
      return null;
    },
  },
};
</script>
